// Weekly-repeat date expansion for schedule shifts. Works on "YYYY-MM-DD"
// strings via UTC calendar arithmetic, so DST transitions in any local
// zone can't shift a date.
export const MAX_REPEAT_WEEKS = 26;

const DAY_MS = 24 * 60 * 60 * 1000;

function toUtcMs(iso: string): number {
  const [y, m, d] = iso.split("-").map(Number) as [number, number, number];
  return Date.UTC(y, m - 1, d);
}

// Every date startDate + 7k days that is <= until (inclusive), in order.
// Returns [] when until < startDate. Throws RangeError when more than
// `max` occurrences would result (callers show an inline message and
// create nothing).
export function expandWeekly(startDate: string, until: string, max = MAX_REPEAT_WEEKS): string[] {
  const start = toUtcMs(startDate);
  const end = toUtcMs(until);
  if (end < start) return [];
  const count = Math.floor((end - start) / (7 * DAY_MS)) + 1;
  if (count > max) {
    throw new RangeError(`Repeat range exceeds ${max} weeks`);
  }
  return Array.from({ length: count }, (_, k) =>
    new Date(start + k * 7 * DAY_MS).toISOString().slice(0, 10),
  );
}
